/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import {
    CONFIRMATION_TYPES_TO_DIALOG_REPO_KEYS,
    CONFIRMATION_TYPES,
} from '../utils/modelMapper/appModelMapper/confirmationDialog/confirmationDialogConstants';
import AppConfig from '../stores/config';
import { AppsPanelSkeleton } from '../stores/skeleton';
import Apps from '../stores/apps';
import { DIALOG_BUTTON_VALUES } from './dialogAnalyticsConstants';
import { ANALYTICS } from '../utils/enums';
import { getAppContentType } from './appTileAnalytics';

class DialogAnalytics {
    dialogLinkClicked(subtype, appData) {
        const dialogType = this.getDialogType(appData);
        const subcategory = DIALOG_BUTTON_VALUES[dialogType]
            && DIALOG_BUTTON_VALUES[dialogType].subcategory;
        this.sendAnalyticObject('click', subtype, subcategory, appData);
    }

    dialogCTAClicked(actionId, operation, appData) {
        const dialogType = this.getDialogType(appData);
        const subtype = DIALOG_BUTTON_VALUES[dialogType]
            && DIALOG_BUTTON_VALUES[dialogType].cta[actionId];
        let subcategory = DIALOG_BUTTON_VALUES[dialogType]
            && DIALOG_BUTTON_VALUES[dialogType].subcategory;
        if (!subcategory) {
            subcategory = operation;
        }
        this.sendAnalyticObject('click', subtype, subcategory, appData);
    }

    dialogRendered(appData) {
        const dialogType = this.getDialogType(appData);
        let subcategory = DIALOG_BUTTON_VALUES[dialogType]
            && DIALOG_BUTTON_VALUES[dialogType].subcategory;
        if (!subcategory) {
            subcategory = CONFIRMATION_TYPES_TO_DIALOG_REPO_KEYS[dialogType];
        }
        this.sendAnalyticObject('render', 'dialog', subcategory, appData);
    }

    getDialogType(appData) {
        const { confirmationDetails } = appData;
        const dialogType = confirmationDetails && confirmationDetails.confirmationType
            && confirmationDetails.confirmationType.toLowerCase();
        return dialogType;
    }

    sendAnalyticObject(type, subtype, subcategory, appData) {
        const obj = {};
        const componentParams = {
            source: ANALYTICS.APPS,
        };
        const sectionFilter = AppsPanelSkeleton.selectedSectionFilter;
        const { confirmationDetails } = appData;
        const appModel = Apps.filterApps({
            sapcode: confirmationDetails.confirmationSAPCode,
            codexVersion: confirmationDetails.confirmationVersion,
        });
        obj.event = {
            workflow: 'Apps',
            type,
            subtype,
            subcategory: `${sectionFilter}:${subcategory}`,
        };
        obj.content = {
            id: confirmationDetails.confirmationSAPCode,
            name: appData.display_name,
            version: confirmationDetails.confirmationVersion,
            category: 'desktop',
            type: appModel.length === 1
                ? getAppContentType({ app: appModel[0], appSectionFilter: sectionFilter })
                : appData.stateCategory,
        };
        const dialogType = this.getDialogType(appData);
        if ((dialogType === CONFIRMATION_TYPES.AUTO_UPDATE_WITH_ADVANCED_OPTIONS
            || dialogType === CONFIRMATION_TYPES.LAUNCH_CONFIRMATION)
            && confirmationDetails.confirmationCheckboxes
            && Array.isArray(confirmationDetails.confirmationCheckboxes)) {
            confirmationDetails.confirmationCheckboxes.forEach((checkBoxValue) => {
                if (checkBoxValue.value === 'keepUpdated'
                || checkBoxValue.value === 'enableAutoUpdate') {
                    obj.event.value = (checkBoxValue.selected === 'true') ? 'enable' : 'disable';
                } else if (checkBoxValue.value === 'dontShowAgain' && type === 'click') {
                    obj.event.value = (checkBoxValue.selected === 'true') ? 'do-not-show' : '';
                }
            });
        }

        if (dialogType === CONFIRMATION_TYPES.ERROR_INFO) {
            obj.event.error_code = appData.error_code;
            obj.event.error_type = appData.error_type;
        }

        AppConfig.analyticsCallback({ componentParams, analyticObjectList: [obj] });
    }
}
export default new DialogAnalytics();
